/**
 * Skills organized by category for Shaurya Singhal.
 * Each category maps to specific branches on the banyan tree.
 * Positions assigned at runtime from aerial root tips.
 *
 * `category` is the skill's primary home (it decides which branch it grows on).
 * `also` lists any further categories it legitimately belongs to — Java is a
 * language *and* a backend tool — so filters can match on more than one.
 */

const skills = [
  // ─── Branch 0: Frontend-1 (3 skills) ───
  { name: "React",      level: 90, color: "#61DAFB", iconify: "simple-icons:react",      category: "Frontend" },
  { name: "JavaScript", level: 92, color: "#F7DF1E", iconify: "simple-icons:javascript", category: "Frontend" },
  { name: "HTML5",      level: 85, color: "#E34F26", iconify: "simple-icons:html5",      category: "Frontend" },

  // ─── Branch 5: Frontend-2 (3 skills) ───
  { name: "SASS",         level: 80, color: "#CC6699", iconify: "simple-icons:sass",          category: "Frontend" },
  { name: "React Native", level: 85, color: "#61DAFB", iconify: "simple-icons:react",         category: "Frontend", also: ["Mobile"] },
  { name: "Redux",        level: 82, color: "#764ABC", iconify: "simple-icons:redux",         category: "Frontend" },

  // ─── Branch 1: Backend (3 skills) ───
  { name: "Node.js",     level: 82, color: "#5FA04E", iconify: "simple-icons:nodedotjs",   category: "Backend" },
  { name: "Spring Boot", level: 75, color: "#6DB33F", iconify: "simple-icons:springboot",  category: "Backend" },
  { name: "Express",     level: 80, color: "#aaaaaa", iconify: "simple-icons:express",     category: "Backend" },

  // ─── Branch 6: Backend-2 (2 skills) ───
  { name: "Kafka", level: 65, color: "#E8E8E8", iconify: "simple-icons:apachekafka", category: "Backend" },
  { name: "REST",  level: 85, color: "#009688", iconify: "simple-icons:fastapi",     category: "Backend" },

  // ─── Branch 2: Languages (3 skills) ───
  { name: "C++",        level: 95, color: "#00599C", iconify: "simple-icons:cplusplus",  category: "Languages" },
  { name: "Java",       level: 80, color: "#ED8B00", iconify: "devicon-plain:java",      category: "Languages", also: ["Backend"] },
  { name: "TypeScript", level: 82, color: "#3178C6", iconify: "simple-icons:typescript", category: "Languages", also: ["Frontend"] },

  // ─── Branch 3: Database-1 (3 skills) ───
  { name: "MongoDB", level: 80, color: "#47A248", iconify: "simple-icons:mongodb",       category: "Database" },
  { name: "MySQL",   level: 80, color: "#4479A1", iconify: "simple-icons:mysql",         category: "Database" },
  { name: "SQL",     level: 82, color: "#E38C00", iconify: "mdi:database",               category: "Database" },
  { name: "PostgreSQL", level: 78, color: "#4169E1", iconify: "simple-icons:postgresql", category: "Database" },

  // ─── Branch 8: Database-2 (2 skills) ───
  { name: "GraphQL", level: 75, color: "#E10098", iconify: "simple-icons:graphql",  category: "Backend", also: ["Frontend"] },
  { name: "Python",  level: 70, color: "#3776AB", iconify: "simple-icons:python",   category: "Languages", also: ["Backend"] },

  // ─── Branch 4: DevOps (3 skills) ───
  { name: "Git",    level: 90, color: "#F05032", iconify: "simple-icons:git",     category: "DevOps" },
  { name: "Bash",   level: 72, color: "#4EAA25", iconify: "simple-icons:gnubash", category: "DevOps" },
  { name: "ESLint", level: 75, color: "#4B32C3", iconify: "simple-icons:eslint",  category: "Tools" },

  // ─── Branch 7: Core (3 skills) ───
  { name: "DSA",           level: 95, color: "#FFA116", iconify: "simple-icons:leetcode",       category: "CS" },
  { name: "System Design", level: 78, color: "#A855F7", iconify: "simple-icons:diagramsdotnet", category: "CS" },
  { name: "Flutter",       level: 70, color: "#02569B", iconify: "simple-icons:flutter",        category: "Frontend", also: ["Mobile"] },

  // ─── Branch 9: AI Tools (3 skills) ───
  { name: "Claude",  level: 88, color: "#D4A27F", iconify: "simple-icons:anthropic", category: "AI" },
  { name: "ChatGPT", level: 85, color: "#10A37F", iconify: "simple-icons:openai",   category: "AI" },
  { name: "Gemini",  level: 82, color: "#4285F4", iconify: "simple-icons:google",   category: "AI" },
];

export default skills;
